// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 20px 0;
  padding: 20px;
  background: #222423;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.pagination-controls .pagination-info {
  text-align: center;
  font-size: 14px;
  color: #A0A0A0;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.pagination-controls .pagination-main-controls {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.pagination-controls .items-per-page-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #181A19;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #181A19;
}
.pagination-controls .items-per-page-selector label {
  font-size: 14px;
  color: #A0A0A0;
  font-weight: 500;
  white-space: nowrap;
}
.pagination-controls .items-per-page-selector select {
  padding: 6px 10px;
  border: 1px solid #181A19;
  border-radius: 4px;
  background: #181A19;
  color: #FFFFFF;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.pagination-controls .items-per-page-selector select:hover {
  background: #4A4D4C;
  border-color: #5A5D5C;
}
.pagination-controls .pagination-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #181A19;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #181A19;
}
@media (max-width: 650px) {
  .pagination-controls .pagination-buttons {
    gap: 2px;
    padding: 6px;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.pagination-controls .pagination-button {
  padding: 8px 12px;
  border: none;
  background: #181A19;
  color: #FFFFFF;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 650px) {
  .pagination-controls .pagination-button {
    padding: 6px 10px;
    min-width: 36px;
    font-size: 13px;
  }
}
.pagination-controls .pagination-button:hover:not(:disabled) {
  background: #4A4D4C;
  border-color: #181A19;
  transform: translateY(-1px);
}
.pagination-controls .pagination-button.active {
  background: linear-gradient(to right, #F08319, #E51B2F);
  color: white;
  border-color: transparent;
  font-weight: 600;
  position: relative;
  z-index: 1;
}
.pagination-controls .pagination-button.active::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  background: linear-gradient(to right, #F08319, #E51B2F);
  border-radius: 4px;
  z-index: -1;
  opacity: 0.8;
}
.pagination-controls .pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #181A19;
  color: #A0A0A0;
  transform: none;
}
.pagination-controls .pagination-ellipsis {
  padding: 8px 6px;
  color: #A0A0A0;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
}
@media (max-width: 650px) {
  .pagination-controls .pagination-ellipsis {
    padding: 6px 4px;
    font-size: 14px;
  }
}
@media (max-width: 650px) {
  .pagination-controls {
    padding: 16px;
    gap: 12px;
  }
  .pagination-controls .pagination-main-controls {
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pagination.sass"],"names":[],"mappings":"AAUA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;AATF;AAWE;EACE,kBAAA;EACA,eAAA;EACA,cAlBa;EAmBb,gBAAA;EACA,qBAAA;AATJ;AAWE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AATJ;AAWE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAtCM;EAuCN,iBAAA;EACA,kBAAA;EACA,yBAAA;AATJ;AAWI;EACE,eAAA;EACA,cAzCW;EA0CX,gBAAA;EACA,mBAAA;AATN;AAWI;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBArDI;EAsDJ,cAnDS;EAoDT,eAAA;EACA,eAAA;EACA,yBAAA;AATN;AAWM;EACE,mBAtDG;EAuDH,qBAAA;AATR;AAWE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAnEM;EAoEN,YAAA;EACA,kBAAA;EACA,yBAAA;AATJ;AAYI;EAVF;IAWI,QAAA;IACA,YAAA;IACA,eAAA;IACA,uBAAA;EATJ;AACF;AAUE;EACE,iBAAA;EACA,YAAA;EACA,mBA7EW;EA8EX,cAhFW;EAiFX,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARJ;AAWI;EAhBF;IAiBI,iBAAA;IACA,eAAA;IACA,eAAA;EARJ;AACF;AASI;EACE,mBA/FK;EAgGL,qBAAA;EACA,2BAAA;AAPN;AASI;EACE,uDAxGY;EAyGZ,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAPN;AASM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uDAtHU;EAuHV,kBAAA;EACA,WAAA;EACA,YAAA;AAPR;AASI;EACE,YAAA;EACA,mBAAA;EACA,mBAhII;EAiIJ,cA7HW;EA8HX,eAAA;AAPN;AASE;EACE,gBAAA;EACA,cAlIa;EAmIb,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAPJ;AAUI;EAXF;IAYI,gBAAA;IACA,eAAA;EAPJ;AACF;AASE;EA3IF;IA4II,aAAA;IACA,SAAA;EANF;EAqBE;IACE,SAAA;EAnBJ;AACF","sourcesContent":["// Переменные цветов\n$dark-bg: #181A19\n$dark-surface: #181A19\n$accent-gradient: linear-gradient(to right, #F08319, #E51B2F)\n$text-primary: #FFFFFF\n$text-secondary: #A0A0A0\n$border-color: #181A19\n$hover-bg: #4A4D4C\n$active-bg: #5A5D5C\n\n.pagination-controls\n  display: flex\n  flex-direction: column\n  gap: 16px\n  margin: 20px 0\n  padding: 20px\n  background: #222423\n  border-radius: 16px\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3)\n\n  .pagination-info\n    text-align: center\n    font-size: 14px\n    color: $text-secondary\n    font-weight: 500\n    letter-spacing: 0.5px\n\n  .pagination-main-controls\n    display: flex\n    flex-direction: column\n    justify-content: space-between\n    align-items: center\n    flex-wrap: wrap\n    gap: 16px\n\n  .items-per-page-selector\n    display: flex\n    align-items: center\n    gap: 10px\n    background: $dark-bg\n    padding: 8px 12px\n    border-radius: 6px\n    border: 1px solid $border-color\n\n    label\n      font-size: 14px\n      color: $text-secondary\n      font-weight: 500\n      white-space: nowrap\n\n    select\n      padding: 6px 10px\n      border: 1px solid $border-color\n      border-radius: 4px\n      background: $dark-bg\n      color: $text-primary\n      font-size: 14px\n      cursor: pointer\n      transition: all 0.2s ease\n\n      &:hover\n        background: $hover-bg\n        border-color: #5A5D5C\n\n  .pagination-buttons\n    display: flex\n    align-items: center\n    gap: 4px\n    background: $dark-bg\n    padding: 8px\n    border-radius: 6px\n    border: 1px solid $border-color\n\n    // Медиа-запрос для мобильных устройств\n    @media (max-width: 650px)\n      gap: 2px\n      padding: 6px\n      flex-wrap: wrap\n      justify-content: center\n\n  .pagination-button\n    padding: 8px 12px\n    border: none\n    background: $border-color\n    color: $text-primary\n    cursor: pointer\n    border-radius: 4px\n    font-size: 14px\n    font-weight: 500\n    transition: all 0.2s ease\n    min-width: 40px\n    display: flex\n    align-items: center\n    justify-content: center\n\n    // Медиа-запрос для мобильных устройств\n    @media (max-width: 650px)\n      padding: 6px 10px\n      min-width: 36px\n      font-size: 13px\n\n    &:hover:not(:disabled)\n      background: $hover-bg\n      border-color: #181A19\n      transform: translateY(-1px)\n\n    &.active\n      background: $accent-gradient\n      color: white\n      border-color: transparent\n      font-weight: 600\n      position: relative\n      z-index: 1\n\n      &::before\n        content: ''\n        position: absolute\n        top: -1px\n        left: -1px\n        right: -1px\n        bottom: -1px\n        background: $accent-gradient\n        border-radius: 4px\n        z-index: -1\n        opacity: 0.8\n\n    &:disabled\n      opacity: 0.5\n      cursor: not-allowed\n      background: $dark-bg\n      color: $text-secondary\n      transform: none\n\n  .pagination-ellipsis\n    padding: 8px 6px\n    color: $text-secondary\n    font-weight: 600\n    font-size: 16px\n    display: flex\n    align-items: center\n    justify-content: center\n    min-width: 20px\n\n    // Медиа-запрос для мобильных устройств\n    @media (max-width: 650px)\n      padding: 6px 4px\n      font-size: 14px\n\n  // Медиа-запрос для мобильных устройств\n  @media (max-width: 650px)\n    padding: 16px\n    gap: 12px\n\n    //.items-per-page-selector\n    //  flex-direction: column\n    //  align-items: center\n    //  gap: 8px\n    //  width: 100%\n    //\n    //  label\n    //    font-size: 13px\n    //\n    //  select\n    //    width: 100%\n    //    text-align: center\n\n    .pagination-main-controls\n      gap: 12px"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
